
export const SearchModal = {
    show: () => {
        // Overlay
        const overlay = document.createElement('div');
        // [FIX] z-index increased to 10005 to overlap Header (10001) & Preview (9999)
        overlay.className = "fixed inset-0 bg-black/60 z-[10005] flex items-start justify-center fade-in pt-16 px-4";

        const modal = document.createElement('div');
        modal.className = "bg-white dark:bg-zinc-900 w-full max-w-2xl rounded-2xl shadow-2xl flex flex-col overflow-hidden animate-slide-up relative";

        const keywords = ["판타지", "로맨스", "먼치킨", "회귀", "빙의", "시스템", "학원물", "드라마", "복수", "성장"];

        modal.innerHTML = `
            <div class="px-4 py-3 border-b border-gray-100 dark:border-zinc-800 flex items-center gap-3">
                <span class="material-symbols-outlined text-gray-400">search</span>
                <input type="text" id="global-search-input" name="globalSearch" aria-label="Search for works, authors, and tags" class="flex-grow text-lg bg-transparent border-none outline-none text-gray-900 dark:text-white placeholder-gray-500" placeholder="작품, 작가, 태그 검색..." autocomplete="off" autofocus>
                <button id="btn-close-search" aria-label="Close search" class="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-zinc-800 text-gray-400">
                    <span class="material-symbols-outlined" aria-hidden="true">close</span>
                </button>
            </div>
            <div id="search-results" class="flex-1 overflow-y-auto min-h-[300px] max-h-[70vh] p-4 bg-gray-50 dark:bg-black/50">
                 <!-- Initial State: Recommended Keywords -->
                 <div class="text-sm font-bold text-gray-500 mb-2">추천 검색어</div>
                 <div id="keyword-container" class="flex flex-wrap gap-2">
                    ${keywords.map(k => `<button class="keyword-btn px-3 py-1 bg-white dark:bg-zinc-800 text-gray-700 dark:text-gray-300 border dark:border-zinc-700 rounded-full text-sm hover:text-blue-500 hover:border-blue-500 transition-colors" data-keyword="${k}">${k}</button>`).join('')}
                 </div>
            </div>
        `;

        overlay.appendChild(modal);
        document.body.appendChild(overlay);

        const input = modal.querySelector('#global-search-input');
        input.focus();

        // Close Handlers
        const close = () => overlay.remove();
        overlay.onclick = (e) => { if (e.target === overlay) close(); };
        modal.querySelector('#btn-close-search').onclick = close;

        // Shared Search Logic
        const performSearch = (query) => {
            if (!query) return;
            close();

            // Try to find existing home search bar first
            const homeSearch = document.querySelector('input[placeholder="작품, 작가, 태그 검색..."]');

            if (homeSearch) {
                homeSearch.value = query;
                homeSearch.scrollIntoView({ behavior: 'smooth', block: 'center' });
                homeSearch.focus();
                homeSearch.dispatchEvent(new Event('input', { bubbles: true }));
            } else {
                // Navigate home with query param
                window.router.navigate(`/?q=${encodeURIComponent(query)}`);
            }
        };

        // Input Enter Handler
        input.onkeydown = (e) => {
            if (e.key === 'Enter') {
                performSearch(input.value.trim());
            }
        };

        // Keyword Click Handler (Event Delegation)
        const keywordContainer = modal.querySelector('#keyword-container');
        if (keywordContainer) {
            keywordContainer.onclick = (e) => {
                if (e.target.classList.contains('keyword-btn')) {
                    const keyword = e.target.getAttribute('data-keyword');
                    performSearch(keyword);
                }
            };
        }
    }
};
